module.exports = __webpack_public_path__ + "static/arrow-left-37a4db5e3792febfce89f7fa7794b96f.png";